<template>
  <div class="modal fade" id="distributorModal" tabindex="-1" role="dialog" aria-labelledby="distributorModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="distributorModalLabel">{{ distributor.company_name }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label" for="adress">Adress</label>
            <input class="form-control" id="adress" readonly
              v-model="distributor.adress"
            >
          </div>

          <div class="form-group">
            <label class="custom-label" for="website">Website</label>
            <input class="form-control" id="website" readonly
              v-model="distributor.website"
            >
          </div>

          <div class="form-group">
            <label class="custom-label">General Manager</label>
            <div class="row">
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-user-tie"></i>
                    </span>
                  </div>
                  <input class="form-control" id="gm_name" readonly
                    v-model="distributor.gm_name"
                  >
                </div>
              </div>
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-phone"></i>
                    </span>
                  </div>
                  <input class="form-control" id="gm_phone" readonly
                    v-model="distributor.gm_phone"
                  >
                </div>
              </div>
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-at"></i>
                    </span>
                  </div>
                  <input class="form-control" id="gm_email" readonly
                    v-model="distributor.gm_email"
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="custom-label">Marketing</label>
            <div class="row">
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-user-tie"></i>
                    </span>
                  </div>
                  <input class="form-control" id="marketing_name" readonly
                    v-model="distributor.marketing_name"
                  >
                </div>
              </div>
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-phone"></i>
                    </span>
                  </div>
                  <input class="form-control" id="marketing_phone" readonly
                    v-model="distributor.marketing_phone"
                  >
                </div>
              </div>
              <div class="col-sm-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width: 50px;">
                      <i class="fa fa-at"></i>
                    </span>
                  </div>
                  <input class="form-control" id="marketing_email" readonly
                    v-model="distributor.marketing_email"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['distributor'],
    data() {
      return {
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/trials/DistributorModal.vue